module.exports = __webpack_public_path__ + "img/13.89008fe5.png";